import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LessonsListPage } from './pages/LessonsListPage';

const LessonDetailPage = lazy(() =>
  import('./pages/LessonDetailPage').then((m) => ({ default: m.LessonDetailPage })),
);
const FlashcardsPage = lazy(() =>
  import('./pages/FlashcardsPage').then((m) => ({ default: m.FlashcardsPage })),
);

export function AppRoutes() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<LessonsListPage />} />
        <Route path="/lessons/:id" element={<LessonDetailPage kind="lesson" />} />
        <Route path="/lessons/:id/practice" element={<FlashcardsPage mode="lesson" />} />
        <Route path="/wordlists/:id" element={<LessonDetailPage kind="wordlist" />} />
        <Route
          path="/wordlists/:id/practice"
          element={<FlashcardsPage mode="wordlist" />}
        />
        <Route path="/practice" element={<FlashcardsPage mode="random" />} />
        <Route path="*" element={<LessonsListPage />} />
      </Routes>
    </Suspense>
  );
}
